import { Component, Injector, Input } from '@angular/core';
import { Events } from 'ionic-angular';

/**
 * Generated class for the Dashboard page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */

@Component({
  selector: 'mediaboxvideo',
  templateUrl: 'mediaboxvideo.html', 
})

export class MediaBoxVideoComponent {

  @Input('domanda') domanda: any;
  // @Input('mq') mq: any;
  // @Input('settingsmq') settingsmq: boolean;
  
  
  constructor(public events: Events) {
  }
  
  
}



// WEBPACK FOOTER //
// ./src/pages/msteps/mediaboxvideo.ts